module.exports = __webpack_public_path__ + "media/newstyle/images/pdf-777872e39da7c7f4a867161b941087a9.png";